exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1 {\n  text-align: center; }\n  h1 img {\n    max-width: 50%; }\n\np {\n  margin-top: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/landing.component.scss
// module id = 140
// module chunks = 1